// extracted by mini-css-extract-plugin
export var container = "destination-module--container--ROZ5a";
export var header = "destination-module--header--yBuRU";
export var card = "destination-module--card--G5h4X";
export var image = "destination-module--image--W8r9g";